import React, { Component } from 'react';

import styles from './GameEnd.scss';
import EndCard from './end-sign.svg';
import Button from 'Components/Button';

class GameEnd extends Component {
  render() {
    let { playerWon, showEndCard, isOver } = this.props;
    playerWon = typeof playerWon !== 'undefined' ? playerWon : false;
    showEndCard = typeof showEndCard !== 'undefined' ? showEndCard : false;
    const displayClass = isOver && showEndCard ? ' is-visible' : '';
    const resultClass = playerWon ? 'GameEnd--won' : 'GameEnd--lost';
    return (
      <div className={`GameEnd ${resultClass}${displayClass}`}>
        <div className="GameEnd__sign">
          <div className="GameEnd__content">
            <div className="GameEnd__title">
              {playerWon ? 'You Won!' : 'Game Over'}
            </div>
            <Button
              text={playerWon ? 'Play Again' : 'Try Again'}
              buttonSize="hero"
              mediaType="games"
              customClass=" GameEnd__button"
              withAction={true}
              actionIcon="again"
              clickHandler={this.props.onReplayGame}
            />
          </div>
          <EndCard />
        </div>
      </div>
    );
  }
}

export default GameEnd;
